// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Unnamed",
    title: "Alivia",
    version: "25.06.26.1",
    tablePrefix: "gen",
    entryPoint: "LeadList",
    loginCollection: "LoginColl",
    autoLogon: false,
    backend: "webcore",
    apiBase: "/api/itf",
    projectId: "alivia",
    defaultLanguage: "javascript",
} as const;
